var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('vTable',{ref:"tableaontact",staticClass:"margin-15",attrs:{"columns":_vm.columns,"data":_vm.datalist,"size":"small","border":""}}),(_vm.loading)?_c('Spin',{attrs:{"size":"large","fix":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }